import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { sendOtp, loginSendOtp, checkOperator, chekUser } from "../../services/AuthService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
import tagManagerEvents from "../../utils/GoogleTagManager";

export interface OtpInputProps {
  msisdn?: string;
  submit?: boolean;
  token?: string;
  _setLoader: (loader: boolean) => void;
  isHttp?: boolean;
  setUserPackage: (pkg: string) => void;
  setIsActive: (isActive: boolean) => void;
  _subscribe: (msisdn: string, pkg?: string) => void;
  otpSent?: boolean;
  utm_source?: string;
  loader?: boolean;
}

export default function OtpInput(props: OtpInputProps) {
  const [phNumber, setphNumber] = useState("");
  const [error, setError] = useState({ Error: "", isTrue: false });

  useEffect(() => {
    if (props.msisdn) {
      setphNumber(props.msisdn);
    }
  }, [props]);

  useEffect(() => {
    if (props.msisdn && props.submit === true && props.token) {
      submit();
    }
  }, [phNumber, props.token]);

  const submit = async () => {
    let re = /^3[0-9]{2}([0-9])(?!\1{6})[0-9]{6}$/g;
    let phCheck = re.test(phNumber);
    let endpoint = `${ApiNames.checkOperator}?msisdn=${phNumber}`;
    props._setLoader(true);

    if (!phNumber) {
      setError((prevState) => ({
        ...prevState,
        Error: "Phone No. is required",
        isTrue: true,
      }));
      props._setLoader(false);
    } else if (!phCheck) {
      setError((prevState) => ({
        ...prevState,
        Error: "Invalid Phone No.",
        isTrue: true,
      }));
      props._setLoader(false);
    } else if (phCheck) {
      tagManagerEvents("Msisdn_Page", props.utm_source);
      let response: any = null;
      if (props.isHttp) {
        try {
          response = await sendOtp(phNumber, props.token);
        } catch (error) {
          response = { response: false, status: "500", message: "Network Error" };
        }
      } else {
        try {
          response = await loginSendOtp(phNumber, props.token);
        } catch (error) {
          response = { response: false, status: "500", message: "Network Error" };
        }
      }

      try {
        let opResponse = await checkOperator(phNumber, props.token);
        if (opResponse?.response?.operator === "Other") {
          setError((prevState) => ({
            ...prevState,
            Error:
              "Service is only available for Jazz customers, kindly enter a working Jazz number",
            isTrue: true,
          }));
          props._setLoader(false);
        } else if (opResponse?.response?.operator === "Mobilink") {
          setError((prevState) => ({
            ...prevState,
            Error: "",
            isTrue: false,
          }));
          props.setUserPackage(opResponse.response.package);
          checkUserSubscription(opResponse.response.package);
        }
      } catch (error) {
        // Fallback if checkOperator fails
        props._setLoader(false);
      }
    }
  };

  const checkUserSubscription = async (userPackage: string) => {
    try {
      let response = await chekUser(phNumber, props.token);
      if (response.status === 200) {
        if (
          response.status === 200 &&
          response.response.desc.toLowerCase() === "active"
        ) {
          props.setIsActive(true);
          props._subscribe(phNumber, userPackage);
        } else {
          props.setIsActive(false);
          props._subscribe(phNumber, userPackage);
        }
      } else {
        props.setIsActive(false);
        props._subscribe(phNumber, userPackage);
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="d-flex align-items-center w-100">
        <div
          className={`${
            props.otpSent ? "bg-light" : "bg-white"
          }  p-2 br-10px ph-shadow`}
        >
          <span className="p-1">+92</span>
        </div>
        <div
          className={`${
            props.otpSent ? "bg-light" : "bg-white"
          }  ms-3 ps-3 br-10px d-flex align-items-center justify-content-between ph-shadow w-100`}
        >
          <div className="py-2">
            <input
              type="tel"
              value={phNumber}
              onChange={(e) => {
                setphNumber(e.target.value);
              }}
              pattern="3[0-9]{2}([0-9])(?!\1{6})[0-9]{6}"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }

                if (event.code === "Enter") {
                  submit();
                }
              }}
              autoComplete="off"
              required
              className="form-control p-0 m-0"
              placeholder="3xx xxxx xxx"
              maxLength={10}
              readOnly={props.otpSent ? true : false}
            />
          </div>
          <div className="d-none d-md-block">
            <button
              className="btn btn-sm btn-red  text-white br-10px py-0 me-1 px-4 fw-bold _hover"
              onClick={submit}
              disabled={props.otpSent ? true : false}
            >
              {props.loader ? (
                <div
                  className="spinner-border text-white spinner-border-sm m-2"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <FontAwesomeIcon
                  icon={solid("arrow-right-long")}
                  className="fa-2x"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      <h1 className="d-none">{error.isTrue.toString()}</h1>
      {error.isTrue ? <small className="text-red">{error.Error}</small> : ""}
      <div className="w-100 d-block mt-3 text-center d-md-none">
        <button
          onClick={submit}
          className="btn btn-sm btn-red w-100 text-white br-10px px-4 py-0 fw-bold _hover"
          disabled={props.otpSent ? true : false}
        >
          {props.loader ? (
            <div
              className="spinner-border text-white spinner-border-sm m-2"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <FontAwesomeIcon
              icon={solid("arrow-right-long")}
              className="fa-2x"
            />
          )}
        </button>
      </div>
    </>
  );
}

OtpInput.defaultProps = {
  otpSent: false,
};
